import * as React from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button, Grid, XFilledIcon, ImageWithCaption, Alert } from 'react-unity';
import NewConnectedPORInfoImage from '../../../images/newConnectedPORInfoImage.png';
import './NewConnectedPORInfoModal.css';

interface NewConnectedPORInfoModalProps {
	visible: boolean;
	onClose: (event: React.ChangeEvent<any>) => void;
}

interface NewConnectedPORInfoModalState {
}

export default class NewConnectedPORInfoModal extends React.Component<
	NewConnectedPORInfoModalProps,
	NewConnectedPORInfoModalState
	> {

	render() {
		return (
			<Modal show={this.props.visible}>
				<Modal.Window id="PORInfoModal" className="em-u-margin-double">
					<Modal.Window.Header>
						<Modal.Window.Header.Title>New Connected Port Opening Request</Modal.Window.Header.Title>
						<Modal.Window.Header.CloseButton onClick={this.props.onClose}>
							<XFilledIcon size='small' />
						</Modal.Window.Header.CloseButton>
					</Modal.Window.Header>
					<Modal.Window.Body>
						<Alert
							variant="warning"
							className="no-alert-actions"
						>
							For connected Port Opening Requests please go to
							the subscriptions page and follow the instructions
							in the image below.
						</Alert>
						<ImageWithCaption
							src={NewConnectedPORInfoImage}
							caption=""
						/>
					</Modal.Window.Body>					
					<Modal.Window.Footer>
						<Grid variant="2-up">
							<Grid.Item>
								<Button variant="secondary" onClick={this.props.onClose}>
									Cancel
								</Button>
							</Grid.Item>
							<Grid.Item>
								<Link to="/subscriptions" className="redirect-button">
									<Button
										variant="primary"
										className="redirect-button"
									>
									Go to Subscriptions
									</Button>
								</Link>
							</Grid.Item>
						</Grid>
					</Modal.Window.Footer>
				</Modal.Window>
			</Modal>
		);
	}
}
